import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/phone.svg'
import _imports_1 from '../../../assets/images/android.svg'
import _imports_2 from '../../../assets/images/tir-shape.svg'


const _hoisted_1 = { className: "bg-[#690722] text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: "flex flex-row mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 flex-wrap pb-[4rem] items-end " }, [
  /*#__PURE__*/_createElementVNode("div", { className: "md:w-2/5 sm:order-2" }, [
    /*#__PURE__*/_createElementVNode("div", { className: "relative top-[4rem]" }, [
      /*#__PURE__*/_createElementVNode("img", {
        className: "m-auto object-contain",
        src: _imports_0,
        alt: "mobilehero"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { className: "md:w-3/5 sm:order-1" }, [
    /*#__PURE__*/_createElementVNode("div", { className: "text-[1.5rem] sm:text-[57px] text-[#ffffff] md:text-[56px] font-[Poppins-Medium] font-[700] leading-[1.1] sm:pt-[4rem] pt-[7rem]" }, " Download Our App "),
    /*#__PURE__*/_createElementVNode("div", { className: "md:w-3/4 pt-4 text-[#ffffff]" }),
    /*#__PURE__*/_createElementVNode("div", { className: "pt-[3rem]  flex" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "android",
        className: "mr-2"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: "tirShape",
        className: "relative bottom-[1.75rem] z-[-1] sm:block hidden"
      })
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}